import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const fadeUp = {
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] },
};

export const Impressum = () => {
  return (
    <div className="overflow-hidden pt-20" data-testid="impressum-page">
      <section className="py-24 md:py-32">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <motion.div {...fadeUp} viewport={{ once: true }}>
            <h1 className="text-4xl md:text-5xl font-bold tracking-tight mb-12">
              Impressum
            </h1>

            <div className="prose prose-invert prose-lg max-w-none">
              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Angaben gemäß § 5 TMG</h2>
                <div className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 text-white/80">
                  <p className="mb-2"><strong className="text-white">MCD Group GmbH</strong></p>
                  <p className="mb-2">Kieshecker Weg 141</p>
                  <p className="mb-4">40474 Düsseldorf</p>
                  <p className="mb-2">Handelsregister: HRB 81265</p>
                  <p>Registergericht: Amtsgericht Düsseldorf</p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Vertreten durch</h2>
                <div className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 text-white/80">
                  <p>Murat Akdere</p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Kontakt</h2>
                <div className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 text-white/80">
                  <p className="mb-2">
                    <strong className="text-white">Telefon:</strong>{' '}
                    <a href="tel:+4915126777707" className="text-[#D4AF37] hover:underline">
                      +49 151 26777707
                    </a>
                  </p>
                  <p>
                    <strong className="text-white">E-Mail:</strong>{' '}
                    <a href="mailto:info@multicleandus.de" className="text-[#D4AF37] hover:underline">
                      info@multicleandus.de
                    </a>
                  </p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Umsatzsteuer-ID</h2>
                <div className="bg-[#0A0A0A] border border-white/10 rounded-xl p-6 text-white/80">
                  <p className="mb-2">
                    <strong className="text-white">Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:</strong>
                  </p>
                  <p className="mb-2">USt.ID: DE317910142</p>
                  <p>St.Nr: 10558292306</p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Streitschlichtung</h2>
                <div className="text-white/70 leading-relaxed space-y-4">
                  <p>
                    Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit:{' '}
                    <a
                      href="https://ec.europa.eu/consumers/odr/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#D4AF37] hover:underline"
                    >
                      https://ec.europa.eu/consumers/odr/
                    </a>
                  </p>
                  <p>
                    Unsere E-Mail-Adresse finden Sie oben im Impressum.
                  </p>
                  <p>
                    Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer 
                    Verbraucherschlichtungsstelle teilzunehmen.
                  </p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Haftung für Inhalte</h2>
                <div className="text-white/70 leading-relaxed space-y-4">
                  <p>
                    Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen 
                    Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind 
                    wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte 
                    fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine 
                    rechtswidrige Tätigkeit hinweisen.
                  </p>
                  <p>
                    Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach 
                    den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung 
                    ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung 
                    möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese 
                    Inhalte umgehend entfernen.
                  </p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Haftung für Links</h2>
                <div className="text-white/70 leading-relaxed space-y-4">
                  <p>
                    Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir 
                    keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine 
                    Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige 
                    Anbieter oder Betreiber der Seiten verantwortlich.
                  </p>
                  <p>
                    Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche 
                    Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung 
                    nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist 
                    jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei 
                    Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                  </p>
                </div>
              </section>

              <section className="mb-12">
                <h2 className="text-2xl font-semibold text-white mb-4">Urheberrecht</h2>
                <div className="text-white/70 leading-relaxed space-y-4">
                  <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten 
                    unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, 
                    Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes 
                    bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                  </p>
                  <p>
                    Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen 
                    Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber 
                    erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden 
                    Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine 
                    Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden 
                    Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte 
                    umgehend entfernen.
                  </p>
                </div>
              </section>

              <div className="mt-12 pt-8 border-t border-white/10">
                <Link
                  to="/datenschutz"
                  className="text-[#D4AF37] hover:underline"
                >
                  Zur Datenschutzerklärung →
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
